/* PANTHERATEC v4.0 | Accessible horizontal category carousel. */
(() => {
  'use strict';
  if (window.__ptSubcategorySliderV39) return;
  window.__ptSubcategorySliderV39 = true;

  function setup(slider) {
    if (slider.dataset.ptcSliderReady === 'true') return;
    const track = slider.querySelector('[data-ptc-subcats]');
    const prev = slider.querySelector('[data-ptc-slider-previous]');
    const next = slider.querySelector('[data-ptc-slider-next]');
    const controls = slider.querySelector('[data-ptc-slider-controls]');
    const counter = slider.querySelector('[data-ptc-slider-position]');
    if (!track || !prev || !next || !controls || !counter) return;
    slider.dataset.ptcSliderReady = 'true';

    let frame = null;
    const cards = Array.from(track.querySelectorAll(':scope > [data-ptc-subcat]'));
    const count = cards.length;
    if (!count) { slider.hidden = true; return; }

    const getMetrics = () => {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const width = cards[0].getBoundingClientRect().width + gap;
      const page = width > 0 ? Math.max(1, Math.floor((track.clientWidth + gap + 2) / width)) : 1;
      return { width, page };
    };

    const update = () => {
      frame = null;
      if (!slider.isConnected) return;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const overflow = max > 3;
      controls.hidden = count < 2;
      controls.dataset.ptcOverflow = overflow ? 'true' : 'false';
      prev.disabled = !overflow || track.scrollLeft <= 3;
      next.disabled = !overflow || track.scrollLeft >= max - 3;
      prev.setAttribute('aria-disabled', String(prev.disabled));
      next.setAttribute('aria-disabled', String(next.disabled));
      if (!overflow) {
        counter.textContent = count + ' Kategorien';
        return;
      }
      const left = track.getBoundingClientRect().left;
      const right = track.getBoundingClientRect().right;
      // Count mostly-visible cards, rather than assuming an integer page size.
      const visible = cards.map((card, idx) => {
        const r = card.getBoundingClientRect();
        const shown = Math.max(0, Math.min(right, r.right) - Math.max(left, r.left));
        return shown >= Math.min(r.width * .5, 65) ? idx : -1;
      }).filter(i => i !== -1);
      const from = visible.length ? visible[0] + 1 : 1;
      const to = visible.length ? visible[visible.length - 1] + 1 : Math.min(count, getMetrics().page);
      counter.textContent = from + '-' + to + ' von ' + count;
    };
    const schedule = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(update);
    };
    const move = (direction) => {
      const metrics = getMetrics();
      const px = Math.max(metrics.width, metrics.width * metrics.page);
      track.scrollBy({
        left: direction * px,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(track);
      slider._ptcResizeObserver = observer;
    } else {
      window.addEventListener('resize', schedule, { passive: true });
    }
    schedule();
  }

  const init = root => {
    if (root.matches?.('[data-ptc-subcat-slider]')) setup(root);
    root.querySelectorAll?.('[data-ptc-subcat-slider]').forEach(setup);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
